import { SkillDiscoveryItemType } from '@gmm/sdk-voodoo/skillDiscovery';

type ValidType = SkillDiscoveryItemType;

export interface WorkItem {
  name: string;
  type: ValidType;
}

export const isTypedItem = (item?: unknown): item is { type: string } =>
  typeof item === 'object' && item !== null && 'type' in item;

const makeTypeGuard = <Type extends string>(types: Type | Type[]) => {
  return <T extends { type: Type }>(item?: unknown): item is T =>
    isTypedItem(item) &&
    (Array.isArray(types)
      ? types.some(type => item.type === type)
      : item.type === types);
};

export const isTagType = makeTypeGuard('Tag');
export const isFolderType = makeTypeGuard('Folder');
export const isAssignmentType = makeTypeGuard('Assignment');
export const isExamTemplateType = makeTypeGuard('ExamTemplate');
export const isExerciseType = makeTypeGuard(['Assignment', 'ExamTemplate']);
export const isSkillType = makeTypeGuard(['Skill', 'LockedSkill']);
export const isRandomSkillType = makeTypeGuard('Skill');
export const isLockedSkillType = makeTypeGuard('LockedSkill');
